<template>
  <div :class="[$style.item, isOpen && $style.open]">
    <div
      :class="$style.header"
      @click="toggle"
    >
      {{ title }}
      <UiIconsArrowTop />
    </div>

    <div
      :style="{ maxHeight: isOpen ? `${bodyHeight}px` : '0' }"
      :class="$style.body"
    >
      <div
        ref="contentEl"
        :class="$style.content"
        v-html="content"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { QuestionItemParams } from './index.js';

defineProps<QuestionItemParams>();

const isOpen = ref<boolean>(false);
const bodyHeight = ref<number>(0);
const contentEl = ref<HTMLElement | null>(null);

const toggle = () => {
  isOpen.value = !isOpen.value;
};

const updateBodyHeight = () => {
  if (contentEl.value) {
    bodyHeight.value = contentEl.value.scrollHeight;
  }
};

watch(isOpen, async () => {
  await nextTick();
  updateBodyHeight();
});

onMounted(() => {
  updateBodyHeight();
});
</script>

<style lang="scss" module>
  .item {
    border-radius: 14px;
    background: #F8F8F8;


    &:not(.open) {

      svg {
        transform: scaleY(-1);
      }
    }
  }

  .header {
    display: flex;
    align-items: center;
    gap: 26px;
    cursor: pointer;
    color: #121E29;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 16px 31px 16px 36px;

    @media (max-width: 767px) {
      font-size: 16px;
    }

    svg {
      flex-shrink: 0;
      width: 15px;
      height: auto;
      margin-left: auto;
      transition: 200ms ease;
    }
  }

  .body {
    overflow: hidden;
    transition: max-height 0.3s ease;

    > *:nth-child(1) {
      margin-top: 0;
      padding-top: 0;
    }

    > *:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }

  .content {
    padding: 0 36px 31px 36px;
    max-width: 690px;
    white-space: break-spaces;
  }
</style>